// @ts-nocheck

(() => {
  const TRIGGER_SELECTOR =
    '[data-rebuy-cart-trigger], [data-testid="cart-drawer-trigger"], .header-actions__action.action__cart';

  let openRetryTimer = null;

  function clearNativeCartDrawerLock() {
    const dialog = document.querySelector(".cart-drawer__dialog");
    if (dialog instanceof HTMLDialogElement && dialog.open) {
      dialog.close();
    }

    // Shared ref-counted lock (defined in dialog.js); fall back to manual clear.
    if (window.ScrollLock && typeof window.ScrollLock.reset === "function") {
      window.ScrollLock.reset();
    } else {
      document.body.style.width = "";
      document.body.style.position = "";
      document.body.style.top = "";
    }
    document.documentElement.removeAttribute("scroll-lock");
    document.documentElement.removeAttribute("body-scroll-locked");
  }

  function openRebuyCartOnce() {
    const smartCart = window.Rebuy?.SmartCart;
    if (!smartCart || typeof smartCart.show !== "function") return false;

    clearNativeCartDrawerLock();
    smartCart.show();
    return true;
  }

  function openRebuyCartWithRetry() {
    if (openRebuyCartOnce()) {
      if (openRetryTimer) {
        window.clearInterval(openRetryTimer);
        openRetryTimer = null;
      }
      return;
    }

    if (openRetryTimer) return;
    let attempts = 0;
    const maxAttempts = 16;
    const intervalMs = 120;

    openRetryTimer = window.setInterval(() => {
      attempts += 1;
      if (openRebuyCartOnce() || attempts >= maxAttempts) {
        if (openRetryTimer) {
          window.clearInterval(openRetryTimer);
          openRetryTimer = null;
        }
      }
    }, intervalMs);
  }

  window.addEventListener(
    "click",
    (event) => {
      const eventTarget = event.target;
      if (!(eventTarget instanceof Element)) return;

      const trigger = eventTarget.closest(TRIGGER_SELECTOR);
      if (!(trigger instanceof HTMLElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();

      openRebuyCartWithRetry();
    },
    { capture: true },
  );

  document.addEventListener("cart:update", (event) => {
    const detail = event.detail;
    if (
      detail?.data?.didError ||
      detail?.data?.source !== "product-form-component"
    )
      return;

    window.requestAnimationFrame(() => {
      clearNativeCartDrawerLock();
      openRebuyCartWithRetry();
    });
  });

  // Scroll lock that keeps the page scrollbar visible.
  // When the Rebuy flyout opens it locks page scroll, which removes the Windows
  // scrollbar and shifts the page (~15px "jank"). The usual fix
  // (`overflow:hidden` + `scrollbar-gutter:stable`) hides the scrollbar and
  // leaves a blank gutter instead. To keep the scrollbar SHOWN, we pin the body
  // at its current scroll offset (position:fixed, like the theme's own
  // ScrollLock) and force the html scrollbar to stay rendered (overflow-y:scroll
  // — an inert track). Nothing is hidden, so the page neither shifts nor shows an
  // empty margin. The CSS lives in app-overrides.css (html[rebuy-scroll-lock]).
  // The forced scrollbar is only applied when one was actually present, to avoid
  // introducing a bar (and a reverse shift) on short, non-scrolling pages.
  (() => {
    const de = document.documentElement;
    let locked = false;
    let lockedScrollY = 0;

    function lock() {
      if (locked) return;
      locked = true;
      lockedScrollY = window.scrollY;
      // Whether to keep a visible scrollbar. We can't measure the live bar width
      // here — Rebuy already set `body{overflow:hidden}`, hiding it before this
      // runs — so test content scrollability instead (still reliable once hidden).
      // Forcing a bar only when the page actually scrolls avoids a reverse shift
      // on short pages that never had one.
      const pageScrollable = de.scrollHeight > window.innerHeight;
      de.style.setProperty("--rebuy-scroll-top", `-${lockedScrollY}px`);
      if (pageScrollable) de.setAttribute("rebuy-keep-scrollbar", "");
      de.setAttribute("rebuy-scroll-lock", "");
    }

    function unlock() {
      if (!locked) return;
      locked = false;
      de.removeAttribute("rebuy-scroll-lock");
      de.removeAttribute("rebuy-keep-scrollbar");
      de.style.removeProperty("--rebuy-scroll-top");
      window.scrollTo({ top: lockedScrollY, behavior: "instant" });
    }

    function syncScrollLock() {
      const cart = document.querySelector("#rebuy-cart");
      const open =
        !!cart &&
        (cart.classList.contains("is-visible") ||
          cart.getAttribute("aria-hidden") === "false");
      if (open) lock();
      else unlock();
    }

    function observeCart() {
      const cart = document.querySelector("#rebuy-cart");
      if (!cart) return false;
      new MutationObserver(syncScrollLock).observe(cart, {
        attributes: true,
        attributeFilter: ["class", "aria-hidden"],
      });
      syncScrollLock();
      return true;
    }

    if (!observeCart()) {
      const bodyObserver = new MutationObserver(() => {
        if (observeCart()) bodyObserver.disconnect();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Recover from a stuck lock after a bfcache restore (back/forward).
    window.addEventListener("pageshow", syncScrollLock);
  })();

  // Sync header cart bubble when Rebuy cart quantities change
  (() => {
    const CART_ITEMS_SEL = '[data-rebuy-component="cart-items"]';
    let syncTimer = null;
    let isSyncing = false;

    /** @param {string} v */
    function normBid(v) {
      return v == null ? '' : String(v).replace(/-/g, '').toLowerCase().trim();
    }

    /** @param {Element} li @param {string} keyLower */
    function getFlyoutProp(li, keyLower) {
      const nameEls = li.querySelectorAll('.rebuy-cart__flyout-item-property-name');
      for (let i = 0; i < nameEls.length; i++) {
        const k = (nameEls[i].textContent || '')
          .trim()
          .replace(/\s*:\s*$/, '')
          .toLowerCase();
        if (k !== keyLower) continue;
        const prop = nameEls[i].closest('.rebuy-cart__flyout-item-property');
        const valEl = prop && prop.querySelector('.rebuy-cart__flyout-item-property-value');
        return valEl ? (valEl.textContent || '').trim() : '';
      }
      return '';
    }

    /** @param {Element} li */
    function isBundleParentRow(li) {
      if (getFlyoutProp(li, 'bundle_parent').toLowerCase() !== 'true') return false;
      return normBid(getFlyoutProp(li, 'bundle_id')) !== '';
    }

    /**
     * Mirrors `snippets/lsg-cart-visible-quantity.liquid`: count line rows, skip bundle parent.
     * @param {Array<{ properties?: Record<string, unknown> | null }> | undefined} items
     * @returns {number}
     */
    function visibleLineCountFromCart(items) {
      if (!items || !items.length) return 0;
      let count = 0;
      for (const item of items) {
        const p = item.properties;
        const parentRaw = p && typeof p === 'object' ? p.bundle_parent : undefined;
        const isParent = parentRaw === true || parentRaw === 'true';
        if (isParent) continue;
        count += 1;
      }
      return count;
    }

    /** @returns {number | null} */
    function visibleLineCountFromFlyout() {
      const root = document.querySelector(CART_ITEMS_SEL);
      if (!root) return null;
      const rows = root.querySelectorAll('.rebuy-cart__flyout-item');
      if (!rows.length) return 0;
      let count = 0;
      rows.forEach((row) => {
        if (isBundleParentRow(row)) return;
        count += 1;
      });
      return count;
    }

    /** @param {number} itemCount @param {unknown} cart */
    function dispatchBubbleUpdate(itemCount, cart) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'rebuy-cart',
            data: { itemCount },
          },
        }),
      );
    }

    function syncCartBubble() {
      if (isSyncing) return;
      isSyncing = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((r) => r.json())
        .then((cart) => {
          let itemCount = visibleLineCountFromCart(cart.items);
          const flyoutCount = visibleLineCountFromFlyout();
          if (flyoutCount !== null) itemCount = flyoutCount;
          dispatchBubbleUpdate(itemCount, cart);
        })
        .catch(() => {})
        .finally(() => {
          isSyncing = false;
        });
    }

    function scheduleSync() {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncCartBubble, 350);
    }

    const rebuyCartEvents = [
      'rebuy:smartcart.cart-updated',
      'rebuy:smartcart:cart-updated',
      'rebuy:smartcart.line-item-removed',
      'rebuy:smartcart:line-item-removed',
      'rebuy:cart.change',
      'rebuy:cart-updated',
      'rebuy:line-item-removed',
      'rebuy.smartcart.line-item-removed',
    ];
    rebuyCartEvents.forEach((name) => document.addEventListener(name, scheduleSync));

    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;
        if (
          event.target.closest(
            '.rebuy-cart__flyout-item-quantity-widget, .rebuy-cart__flyout-item-remove, [data-rebuy-action="remove"], .rebuy-cart__flyout-item__remove',
          )
        ) {
          scheduleSync();
        }
      },
      { capture: true },
    );

    let flyoutObserver = null;

    function observeRebuyFlyout() {
      const flyout = document.querySelector('.rebuy-cart__flyout');
      if (!flyout || flyoutObserver) return !!flyoutObserver;

      flyoutObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          const el = m.target instanceof Element ? m.target : null;
          const parentEl = m.target.parentElement;
          const target = el || parentEl;
          if (!target) continue;
          if (
            target.closest('.rebuy-cart__flyout-items') ||
            target.closest('.rebuy-cart__flyout-item-quantity-widget') ||
            target.classList.contains('rebuy-cart__flyout-items')
          ) {
            scheduleSync();
            return;
          }
        }
      });

      flyoutObserver.observe(flyout, { childList: true, subtree: true, characterData: true });
      return true;
    }

    if (!observeRebuyFlyout()) {
      const bodyObserver = new MutationObserver(() => {
        if (observeRebuyFlyout()) bodyObserver.disconnect();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    syncCartBubble();
    window.addEventListener('pageshow', scheduleSync);
    window.addEventListener('focus', scheduleSync);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) scheduleSync();
    });
  })();

  // Rebuy flyout: nested scroll (Lenis) + pause page smooth scroll while open
  (() => {
    let lenisPausedForCart = false;
    let flyoutScrollObserver = null;
    let lastFlyoutOpen = false;

    /** @param {Element | null} flyout */
    function isRebuyFlyoutOpen(flyout) {
      if (!flyout) return false;
      return (
        flyout.classList.contains("active") ||
        flyout.classList.contains("is-active") ||
        flyout.getAttribute("aria-hidden") === "false"
      );
    }

    /** @param {boolean} active */
    function setLenisForRebuyCart(active) {
      const lenis = window.__288Lenis;
      if (!lenis) return;
      if (active) {
        if (!lenisPausedForCart && typeof lenis.stop === "function") {
          lenis.stop();
          lenisPausedForCart = true;
        }
        return;
      }
      if (lenisPausedForCart && typeof lenis.start === "function") {
        lenis.start();
        lenisPausedForCart = false;
      }
    }

    /** @param {Element} flyout */
    function applyFlyoutLenisPrevent(flyout) {
      const scrollEl =
        flyout.querySelector(".rebuy-cart__flyout-inner") || flyout;
      scrollEl.setAttribute("data-lenis-prevent", "");
    }

    /** @param {Element} flyout */
    function syncFlyoutScrollState(flyout) {
      applyFlyoutLenisPrevent(flyout);
      const open = isRebuyFlyoutOpen(flyout);
      if (open !== lastFlyoutOpen) {
        lastFlyoutOpen = open;
        setLenisForRebuyCart(open);
      }
    }

    function observeRebuyFlyoutScroll() {
      const flyout = document.querySelector(".rebuy-cart__flyout");
      if (!flyout) return false;

      syncFlyoutScrollState(flyout);

      if (flyoutScrollObserver) return true;

      flyoutScrollObserver = new MutationObserver(() => {
        syncFlyoutScrollState(flyout);
      });
      flyoutScrollObserver.observe(flyout, {
        attributes: true,
        attributeFilter: ["class", "aria-hidden"],
        childList: true,
        subtree: true,
      });
      return true;
    }

    if (!observeRebuyFlyoutScroll()) {
      const bootObserver = new MutationObserver(() => {
        if (observeRebuyFlyoutScroll()) bootObserver.disconnect();
      });
      bootObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();
})();
